import React, { useCallback } from "react";

import { endOfDay, endOfYesterday, isAfter, startOfDay } from "date-fns/esm";
import { useIntl } from "react-intl";

import { Labeled } from "@mapmycustomers/ui";

import RangePicker from "@app/component/input/RangePicker";
import DateRange from "@app/scene/reports/types/DateRange";

export const onlyPastDatesAllowed = (date: Date) => isAfter(date, endOfYesterday());

interface Props {
  className?: string;
  disabled?: boolean;
  isDateDisabled?: (date: Date) => boolean;
  label?: React.ReactNode;
  onChange?: (value: DateRange) => void;
  value?: DateRange;
}

const CustomRangePicker: React.FC<Props> = ({
  className,
  disabled,
  isDateDisabled = onlyPastDatesAllowed,
  label,
  onChange,
  value,
}) => {
  const intl = useIntl();

  const handleDateRangeChange = useCallback(
    (dates) => {
      if (dates[0] && dates[1]) {
        onChange?.({
          endDate: endOfDay(dates[1]),
          startDate: startOfDay(dates[0]),
        });
      }
    },
    [onChange]
  );

  return (
    <Labeled
      label={
        label ??
        intl.formatMessage({
          id: "dateRangeSelect.custom",
          defaultMessage: "Select range",
          description: "Custom range picker label in range selector component",
        })
      }
    >
      <RangePicker
        className={className}
        disabled={disabled}
        disabledDate={isDateDisabled}
        onChange={handleDateRangeChange}
        value={[value?.startDate ?? null, value?.endDate ?? null]}
      />
    </Labeled>
  );
};

export default CustomRangePicker;
